var _style, _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerTacoGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    width: 800,
    height: 800,
    role: "img",
    "aria-label": "Taco icon gold",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gold Taco Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .a{fill:#fef08a}\n    .b{fill:#f59e0b}\n    .c{fill:#fde68a}\n    .d{fill:#b45309}\n    .e{fill:#92400e}\n    .f{fill:#7c2d12}\n    .g{fill:#fbbf24}\n    .h{fill:#fef3c7}\n    .i{fill:#facc15}\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "tacoGoldGlow",
    cx: 400,
    cy: 520,
    r: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fef08a",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    stopColor: "#facc15",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#facc15",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 520,
    r: 340,
    fill: "url(#tacoGoldGlow)",
    opacity: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m278.5 662.6l-25.2 44.8c0 0 42.6-11 84.6-38.9 42-27.9 77-71.1 156.2-122.4 87.5-56.6 198.2-67.5 255.3-130.5 44.9-49.5 42.6-118.7 19.8-176-25.1-62.8-61.9-86.2-61.9-86.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m601.3 203.4c4.7-3.5-65.2-76.9-65.2-76.9 0 0-113.1-83.9-273.9-15.1-160.8 68.7-256.4 263.4-237.8 419.5 16.6 138.5 79.8 185.9 146.7 182.9 103.7-4.7 155.6-73.5 155.6-73.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m525.4 132.9c0 0-66.3-60-215.5-19.2-149.1 40.8-278.5 228.4-269.1 393.9 9 161 80.4 145.7 80.4 145.7 0 0 202.7-318.1 208.6-322.8 5.8-4.7 195.6-197.6 195.6-197.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m196.4 686c0 0-41.8 15.8-71.2 3.7-29.3-12.1-46.9-46.6-45.5-65.7 2.3-30.1 26.3-33.4 26.3-33.4l44-81.3-54.1-115.2c0 0-3.5-22.2 4.1-32.3 7.6-10.1 17.7-15.2 30.8-17.7 13.1-2.5 82.9-48.5 82.9-48.5 0 0-13.7-42.5 9-71.8 22.8-29.3 44.5-32.3 44.5-32.3 0 0 15.7-4.6 35.4-0.5 19.6 4.1 29.3 10.1 29.3 10.1l35.3-23.2 58.2-4.1c0 0 6.5-12.1 7.5-16.2 1-4 1-20 26.8-36.2 25.8-16.2 45.4-11.8 52.5-10.3 13 2.7 22.1 8.9 26 19.4 5.5 15-4.7 71.1-4.7 71.1l-274.7 428z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m199.6 341.8l-80.5 20.6c0 0-0.7 36.9 23.1 52.2 23.7 15.3 40.1 10.6 76.5 5.3 36.4-5.3 75.4-9.5 83.3-24.8 7.9-15.4 0-32.7-12.1-46.5-12.1-13.7-32.9-34.6-32.9-34.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m101 532.8l-12.8-7.2c0.1 0-2.3 15.1-2.4 24.1-0.4 17.2 10.6 33.5 10.6 33.5 0 0-3.5 35.5-1.3 41.3 2.1 5.8 104 24.9 104 24.9l33.3-11.1 31.6-108.7-87.1-9.5c0 0-74.3 10.1-75.9 12.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m446.1 188.1l-38.1 29.3c0 0 2.9 16.4 19.9 20.4 17 4 38.1-14.9 50.8-25.4 12.7-10.5 38.7-39.9 35.5-43.8-3.3-4-36.3-8-36.3-8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m431.6 216.3c10.9-1.9 56.8-53.6 57.6-56.9 0.7-3.2-39.1-13.7-52.9-6.8-13.7 6.8-33 21-33.7 35.1-0.7 14.1-0.4 27.5 5.5 29.7 5.7 2.2 15.2 0.4 23.5-1.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m166.5 399c21.2 0.9 66.6-12.1 87.3-30.8 20.6-18.6 10.5-42.8 7.5-48.9-3-6.1-22.2-28.2-42.4-28.7-20.2-0.5-92.3 37.8-98.8 59.5-6.5 21.7 7.6 29.2 16.1 35.8 8.6 6.5 17.7 12.6 30.3 13.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m259.3 484.2c0 0 4.1-11.1 4.1-18.1 0-7.1-7.1-22.7-15.2-19.2-8 3.5-32.7 40.9-32.7 40.9 0 0-28.3-19.7-59-17.2-30.8 2.6-52.4 27.3-60.5 38.8-8.1 11.6-8.7 18.3-8.1 26 0.5 7.8 22.2 32 31.3 38.1 9.1 6.1 60.5 7.1 67 3 6.6-4.1 36.4-33.3 41.4-43.4 5.1-10 31.7-48.9 31.7-48.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m161.9 603.8c0 0-18.1-13.7-26.7-16.2-8.6-2.5-36.3 1-38.8 9.1-2.5 8.1-3 20.2-2 28.2 1 8.1 15.1 33.9 19.7 40.4 4.5 6.5 35.3 21.1 42.8 21.1 7.6 0 29.8-0.5 33.3-3.5 3.5-3 3.5-20.5-1-35.3-5.1-16.7-27.3-43.8-27.3-43.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m163.9 272.1c-1.3 4.5-4.5 37.8 2.5 42.8 7.1 5.1 46.4-12.1 47.4-17.1 1-5.1-1.5-34.3-6.5-42.4-5.1-8-40.4 6.6-43.4 16.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m231.6 178.1c-11.2 3.7-20.2 50-14.7 55 5.6 5 48.5 12.1 55 7 6.5-5 8.5-39.3 4.5-43.8-4-4.5-32.7-22.2-44.8-18.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m616.8 140.8c0 0 3-24.7-9-27.2-12.2-2.5-18.7 13.6-18.7 13.6 0 0-7.1-27.3-20.2-29.3-8.7-1.3-28.3 9.6-31.8 20.7-3.5 11.1-4.5 22.7-4.5 22.7 0 0-16.2-4.1-11.2 12.6 5.1 16.7 10.1 33.8 10.1 33.8 0 0 85.3-47.9 85.3-46.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m316.8 193.8c2.2 9.9 16.6 27.7 22.1 28.2 5.6 0.5 42.9-27.8 42.4-35.8-0.5-8.1-15.1-38.8-26.2-41.4-11.2-2.6-40.9 37.8-38.4 48.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m400.4 143.3c-15.1-4.1-25.2 30.2-22.2 36.3 3 6 22.7 10 31.2 3.5 8.6-6.6 4.8-36.2-9-39.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m292.6 474.6c13.3 4.5 38.8-54.9 38.8-69 0-14.2-27.8-28.8-35.8-24.7-8.1 4-34.4 41.8-34.4 51.4 0.1 9.6 20.8 38.8 31.4 42.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m304.7 532.6c0 0-29.3-53.9-33.8-59-4.6-5-12.6-11.6-23.2-1.5-10.6 10.2-24.2 46.4-21.7 56.5 2.5 10.2 20.2 26.3 19.2 28.3-1 2-32.3 11.1-35.3 25.2-3 14.1 7.5 53.9 15.6 59.5 8.1 5.5 27.3 0.5 27.3 0.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m85.3 394.9c-11.1 0-6.5 18.2-5 28.3 1.5 10-2 23.2 11.1 24.2 13.1 1 42.4-7.6 42.4-7.6 0 0-1-11.1-7.6-24.7-6.6-13.6-8.1-21.7-15.1-20.7-7.1 1-25.8 0.5-25.8 0.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m163 470.6c4.1 14.1-37.8 43.4-50.9 38.3-21.4-8.2-32.8-36.3-28.8-52.9 4.1-16.6 45.4-26.3 52.5-26.3 7 0 23.6 28.5 27.2 40.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m153.9 441.9c1.5 21.2 15.5 46.1 29.2 46.9 9.1 0.5 24.9-11.7 37.3-20.2 12.7-8.6 22.2-17.7 27.3-23.7 5.1-6.1-7.6-23.2-15.1-32.3-7.6-9-16.2-14.3-22.7-12.6-11.2 3-17.2 7.1-31.3 16.1-8.5 5.5-25.5 14.6-24.7 25.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m143.3 532.1c0.5 13.3 9.6 14.6 20.2 19.7 10.6 5.1 21.2 8.1 27.7 1.5 6.6-6.6 11.7-41.9 8.6-51.4-3-9.6-25.2-14.2-34.3-11.2-6.9 2.4-22.7 27.3-22.2 41.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m219.9 266.4c3.9 11 27.8 24.2 36.8 20.7 9.1-3.5 14.2-44.9 11.7-54.5-2.5-9.5-40.3-5.5-44.4 0.5-4.1 6-7.1 24.7-4.1 33.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m272.9 267.4c-2 9.9 14.7 23.2 18.7 25.2 4.1 2 12.2 2 12.2 2 0 0-8.1 16.6-11.7 26.7-3.5 10.1-11.6 34.8-4 38.3 7.5 3.5 46.8 9.1 53.4-0.5 6.6-9.5 16.6-54.9 11.1-62-5.5-7-39.3-7.5-39.3-7.5 0 0 10.6-5.6 13.1-11.2 2.6-5.5-12.1-25.6-22.1-27.2-10.2-1.4-29.4 6.1-31.4 16.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m289.6 231.1c1.3 8.6 14.6 17.1 26.7 15.1 12.1-2 15.6-32.8 12.6-35.8-3-3.1-19.2-8.1-24.7-5.1-5.6 3.1-15.6 19.2-14.6 25.8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m351.6 227.6c-4.2 14.3 9.2 39.6 23.1 41.8 12.7 2 45.4-20.1 50-29.2 4.6-9.1-21.7-36.8-29.3-37.8-7.5-1-20.7 8.5-25.7 12.1-5 3.4-16.1 6-18.1 13.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m483.2 128.7c-6.7 4.1-10 40-4.6 49.4 5.6 9.6 36.3 6.1 46.9-8.5 5.6-7.7 4.1-40.3-1-42.4-5-2-34.7-2.5-41.3 1.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m243.9 650.6c0 0-5.7-14.8-16.7-18.2-11-3.5-33 11.7-33 11.7 0 0-3.5-34.9-10.6-42-7.2-7.2-26.2-3.9-30.7-1.5-4.6 2.2-19 11.3-19.7 16.6-0.8 5.4 0.4 44.4 9.9 47.8 9.5 3.4 16.6 5.3 23.8 4.2 7.2-1.1 18.2-5.7 18.2-5.7 0 0-3.4 15.2 1.9 20.4 5.3 5.3 23.9-0.3 25-1.1 1.2-0.8 31.9-32.2 31.9-32.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m225.7 706.6l-44.8-16.2c0 0 20.5-2 40.5-23.5 30.2-32.5 60.3-104.3 81-158.6 20.7-54.4 41.4-112.1 69.8-169 28.5-56.9 86.4-129.7 146.6-174.1 74.1-54.6 152-26.9 152-26.9l-20.1 175.2-347.4 354.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m705.3 365.6c51.2-58.7 54.3-136.1 31.6-180.5-24.1-47.5-91.3-57.8-133.6-45.7-42 12-122.4 50.8-184.5 162.9-62.1 112.1-122.2 302.7-153.4 349.1-21.4 32-44.4 48.1-63.9 55.8-23.4 9.3-46.7 6.2-46.7 6.2 0 0 69.3 12.2 118.4-14.5 49.1-26.8 82.7-67.9 121.6-113.8 15.8-18.7 64.8-70.7 118.1-104.4 53.2-33.7 145-60.8 192.4-115.1z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m363.1 520.4c13.3 0.7 17-10.5 18.3-19.7 1.4-9.2-1.3-21.1-12.3-22.5-8.7-1.1-16.1 5.1-18.4 18.8-2.1 12.3 2.7 22.9 12.4 23.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m360.8 569.6c-7.4-4-17 1.8-20.7 9.6-3.7 7.8-3.7 18.4 3.2 22 6.9 3.7 15.4 0.9 20.7-9.6 4.6-9.2 3.7-18.4-3.2-22z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m392.9 554.4c-11.9-7.4-6.8-21.6 0-32.1 6.9-10.6 18.4-18.9 27.6-12.9 9.2 6 5.5 20.7-0.4 30.7-4.8 8.2-16 21.2-27.2 14.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerTacoGold);
export default __webpack_public_path__ + "static/media/marker-taco-gold.a0a100f9c0cae2a133f16aa12d52ca31.svg";
export { ForwardRef as ReactComponent };